import { useEffect, useRef, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import "./globalCapDetailClosingCta.css";

export default function GlobalCapDetailClosingCta({ data }) {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    if (typeof IntersectionObserver === "undefined") {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    observer.observe(node);

    return () => observer.disconnect();
  }, []);

  if (!data) return null;

  return (
    <section
      ref={ref}
      className={`gcdc ${visible ? "gcdc--visible" : ""}`}
    >
      <div className="gcdc__panel">
        <div className="gcdc__grid" aria-hidden="true" />

        <div className="gcdc__content">
          <span className="gcdc__rule" aria-hidden="true" />
          <h2 className="gcdc__title">{data.headline}</h2>
          {data.body && <p className="gcdc__body">{data.body}</p>}

          {data.cta && (
            <a href={data.cta.href} className="gcdc__button">
              {data.cta.label}
              <span className="gcdc__button-icon" aria-hidden="true">
                <ArrowUpRight size={18} strokeWidth={2} />
              </span>
            </a>
          )}
        </div>

        <div className="gcdc__visual" aria-hidden="true">
          <svg className="gcdc__rings" viewBox="0 0 400 400" focusable="false">
            <circle className="gcdc__ring gcdc__ring--a" cx="200" cy="200" r="190" />
            <circle className="gcdc__ring gcdc__ring--b" cx="200" cy="200" r="145" />
            <circle className="gcdc__ring gcdc__ring--c" cx="200" cy="200" r="100" />
            <circle className="gcdc__ring gcdc__ring--d" cx="200" cy="200" r="58" />
            <g className="gcdc__orbit gcdc__orbit--a">
              <circle cx="200" cy="10" r="5" />
            </g>
            <g className="gcdc__orbit gcdc__orbit--b">
              <circle cx="345" cy="200" r="4" />
            </g>
            <g className="gcdc__orbit gcdc__orbit--c">
              <circle cx="200" cy="300" r="3.5" />
            </g>
          </svg>
          <span className="gcdc__core">
            <ArrowUpRight size={30} strokeWidth={1.8} />
          </span>
        </div>
      </div>
    </section>
  );
}
